/**
 * Normalise une date API (ISO `…T…`, SQL `Y-m-d H:i:s`, etc.) en `YYYY-MM-DD`
 * pour `<input type="date">`, MUI DatePicker / parseYmd strict.
 */
export function toYmdForDateInput(raw: string | null | undefined): string | null {
  const s = String(raw ?? '').trim();
  if (!s) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  if (s.length >= 10 && s.charAt(10) === 'T') return s.slice(0, 10);
  const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
  if (m?.[1]) return m[1];
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, '0');
  const da = String(d.getDate()).padStart(2, '0');
  return `${y}-${mo}-${da}`;
}
